import { JsonPipe, NgIf, NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
  ViewChild,
  ContentChild,
    EventEmitter
} from '@angular/core';
import {
  MatExpansionModule,
  MatExpansionPanel,
} from '@angular/material/expansion';
import { CommunityItem } from '@trp/community/interfaces';

import { LazyCardContentDirective } from './lazy-card-content.directive'
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'trp-community-expandable-card',
  standalone: true,
  imports: [TranslateModule, MatExpansionModule, NgIf, NgTemplateOutlet],
  templateUrl: './community-expandable-card.component.html',
  styleUrls: ['./community-expandable-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommunityExpandableCardComponent {
  @Input() item!: CommunityItem;
  @ViewChild(MatExpansionPanel, { static: true })
  expansionPanelEl: MatExpansionPanel | null = null;
  expanded = false;

  @Output() opened = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  @ContentChild(LazyCardContentDirective)
  lazyCardContent?: LazyCardContentDirective;

  onOpened() {
    this.expanded = true;
    this.opened.emit();
  }

  onClosed() {
    this.expanded = false;
    this.closed.emit();
  }

  openPanel() {
    if (this.expansionPanelEl) {
      this.expansionPanelEl.open();
    }
  }
}
